import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const CSharp = () => {
  return (
    <StartInterviewLayout type="csharp"/>
  )
}

export default CSharp;